<template>
  <div class="transfer-page">
    <div class="banner-top">
      <div class="banner-box">请完成对公转账，款项到账后自动开通服务</div>
    </div>
    <div class="transfer-box">
      <div class="back-bar">
        <el-button size="small" icon="el-icon-arrow-left" @click="goOrderList">返回订单列表</el-button>
      </div>

      <!-- 订单信息 -->
      <div class="section-card">
        <div class="section-title">订单信息</div>
        <div class="info-list">
          <div class="info-item"><span class="label">订单编号：</span><span class="value">{{ order_id }}</span></div>
          <div class="info-item"><span class="label">应付金额：</span><span class="amount">￥{{ amount }}</span><span class="tax">（含税）</span></div>
          <div class="info-item"><span class="label">套餐名称：</span><span class="value">{{ package_name }}</span></div>
          <div class="info-item"><span class="label">订单有效期：</span><span class="value">生成之日起7个工作日内有效，逾期未到账自动失效</span></div>
        </div>
      </div>

      <!-- 收款账户信息 -->
      <div class="section-card account-card">
        <div class="section-title">收款账户信息</div>
        <div class="account-list">
          <div class="account-row">
            <span class="account-label">账户名：</span>
            <span class="account-value">{{ account.name }}</span>
            <el-button size="mini" class="copy-btn" @click="copyText(account.name)">复制</el-button>
          </div>
          <div class="account-row">
            <span class="account-label">账号：</span>
            <span class="account-value account-num">{{ account.no }}</span>
            <el-button size="mini" class="copy-btn" @click="copyText(account.no)">复制</el-button>
          </div>
          <div class="account-row">
            <span class="account-label">开户行：</span>
            <span class="account-value">{{ account.bank }}</span>
            <el-button size="mini" class="copy-btn" @click="copyText(account.bank)">复制</el-button>
          </div>
          <div class="account-row">
            <span class="account-label">行号：</span>
            <span class="account-value account-num">{{ account.code }}</span>
            <el-button size="mini" class="copy-btn" @click="copyText(account.code)">复制</el-button>
          </div>
        </div>
      </div>

      <!-- 重要提醒 -->
      <div class="section-card">
        <div class="section-title">重要提醒</div>
        <ol class="remind-list">
          <li>请务必在汇款备注中填写：订单编号+注册手机号，无备注将无法核对到账，影响服务开通；</li>
          <li>支持对公账户、个人银行卡转账，不支持现金、第三方平台转账至私人账户；</li>
          <li>工作日每日17:00前统一核对到账，到账后1个工作日内开通服务并发送通知；</li>
          <li>转账手续费由汇出方承担，我方不承担跨行、跨地区转账手续费。</li>
        </ol>
      </div>

      <!-- 操作按钮 -->
      <div class="action-bar">
        <el-button type="primary" class="btnBg" @click="onConfirmTransfer">我已完成转账</el-button>
        <el-button @click="goOrderList">返回订单列表</el-button>
      </div>
    </div>

    <!-- 二次确认弹窗 -->
    <el-dialog title="温馨提示" :visible.sync="confirmDialog" width="520px" :close-on-click-modal="false">
      <div class="dialog-content">
        <p>提交转账凭证后，我们将在1个工作日内核对银行到账情况。若实际款项未到账，服务将无法开通，请您确认转账操作已完成。</p>
        <p>如有疑问可联系客服：13396040230（赵女士微信同号）</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmDialog = false">取消</el-button>
        <el-button type="primary" class="btnBg" :loading="submitting" @click="doConfirmTransfer">确认提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { confirmTransfer } from "@/api/order";
export default {
  name: "OrderTransfer",
  data() {
    return {
      username: window.localStorage.getItem('username'),
      order_id: this.$route.query.order_id || '',
      amount: this.$route.query.amount || 0,
      package_name: this.$route.query.package_name || '',
      confirmDialog: false,
      submitting: false,
      account: {
        name: '武汉博览财经信息技术股份有限公司',
        no: '42050111625600000772',
        bank: '中国建设银行股份有限公司武汉水利支行',
        code: '105521000342',
      },
    }
  },
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
  },
  methods: {
    copyText(text) {
      if (!text) return;
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success({message: '已复制', duration: 1000, offset: 400});
        }).catch(() => {
          this.execCopy(text);
        });
      } else {
        this.execCopy(text);
      }
    },
    execCopy(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        const ok = document.execCommand('copy');
        if (ok) {
          this.$message.success({message: '已复制', duration: 1000, offset: 400});
        } else {
          this.$message.error({message: '复制失败，请手动复制', duration: 1500, offset: 400});
        }
      } catch (e) {
        this.$message.error({message: '复制失败，请手动复制', duration: 1500, offset: 400});
      }
      document.body.removeChild(textarea);
    },
    onConfirmTransfer() {
      this.confirmDialog = true;
    },
    doConfirmTransfer() {
      this.submitting = true;
      const data = {
        order_id: this.order_id,
        username: this.username,
        action: 'confirm_transfer',
      };
      // 未登录用户传 auto_register 信息
      if (!this.token) {
        const phone = sessionStorage.getItem('pendingPhone') || '';
        if (phone) {
          data.phone = phone;
          data.auto_register = true;
        }
      }
      confirmTransfer(data).then((response) => {
        this.submitting = false;
        if (response && (response.code === 2000 || response.code === 200)) {
          // 保存自动注册的账号信息
          if (response.data && response.data.account) {
            sessionStorage.setItem('newAccount', JSON.stringify(response.data.account));
          }
          this.$router.push({path: '/PaySuccess', query: {type: 'transfer', order_id: this.order_id}});
        } else {
          this.$message.error({message: (response && response.msg) || '提交失败，请稍后重试', duration: 2000, offset: 400});
        }
      }).catch((err) => {
        this.submitting = false;
        this.$message.error({message: '提交失败，请稍后重试', duration: 2000, offset: 400});
        console.log(err);
      });
    },
    goOrderList() {
      this.$router.push({path: '/UCenter'});
    },
  }
}
</script>

<style scoped>
.banner-top {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  background: url("../assets/images/banner_top.png") no-repeat center / cover;
  text-align: center;
  color: #fff;
}
.banner-box {
  font-size: 26px;
  font-weight: 600;
  line-height: 100px;
}
.transfer-box {
  width: 1200px;
  margin: 20px auto 40px;
}
.back-bar {
  margin-bottom: 16px;
}
.section-card {
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 20px 24px;
  margin-bottom: 20px;
}
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #001646;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 16px;
}
.info-item {
  font-size: 15px;
  line-height: 36px;
  color: #313131;
}
.info-item .label {
  color: #898989;
}
.info-item .amount {
  color: #d4380d;
  font-size: 22px;
  font-weight: 700;
}
.info-item .tax {
  color: #d4380d;
  font-size: 13px;
  margin-left: 4px;
}
.account-card {
  background: #f6f9ff;
  border: 1px solid #d6e4ff;
}
.account-row {
  display: flex;
  align-items: center;
  font-size: 15px;
  line-height: 44px;
  color: #313131;
}
.account-label {
  width: 90px;
  color: #898989;
  flex-shrink: 0;
}
.account-value {
  color: #001646;
  font-weight: 600;
  margin-right: 16px;
}
.account-num {
  letter-spacing: 1px;
  font-family: Consolas, Monaco, monospace;
}
.copy-btn {
  margin-left: 8px;
}
.remind-list {
  padding-left: 20px;
  color: #595959;
  font-size: 14px;
}
.remind-list li {
  line-height: 28px;
  margin-bottom: 6px;
}
.action-bar {
  text-align: center;
  padding: 10px 0 20px;
}
>>> .action-bar .el-button {
  width: 200px;
  height: 44px;
  font-size: 15px;
  margin: 0 12px;
}
.dialog-content p {
  font-size: 14px;
  line-height: 26px;
  color: #595959;
  margin-bottom: 6px;
}
>>> .btnBg {
  background-color: #001646 !important;
  border-color: #001646 !important;
}
>>> .btnBg:hover,
>>> .btnBg:focus {
  background-color: #0a2a6e !important;
  border-color: #0a2a6e !important;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderTransfer.vue